import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  hpFile: [],
};


const hpSlice = createSlice({
    name: "hp",
    initialState,
    reducers: {
        getAllHpFile(state, action){
            state.loading = false;
            state.hpFile = action.payload;
            state.loading = true;
        },
      loading(state, action) {
        state.loading = action.payload;
      },
    },
  });

  export default hpSlice.reducer;
  export const {
    getAllHpFile,
    loading
  } = hpSlice.actions;